import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

const NOTICE_KEY = "oaria-cookie-notice-dismissed";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (window.location.search.includes("admin_heatmap_preview=1")) return;
    const dismissed = localStorage.getItem(NOTICE_KEY);
    if (!dismissed) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(NOTICE_KEY, "1");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 300 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6"
        >
          <div className="mx-auto max-w-2xl rounded-2xl border border-border bg-background/95 px-5 py-4 shadow-lg backdrop-blur-md sm:px-6">
            <div className="flex items-start gap-3">
              <Cookie className="mt-0.5 h-5 w-5 flex-shrink-0 text-muted-foreground" />
              <div className="flex-1">
                <p className="text-sm leading-relaxed text-foreground">
                  We use cookies and similar technologies for site functionality, analytics,
                  and to share data with advertising partners. See our{" "}
                  <a
                    href="/pages/privacy-policy"
                    className="underline underline-offset-2 transition-colors hover:text-muted-foreground"
                  >
                    Privacy Policy
                  </a>
                  . US residents can manage sharing under{" "}
                  <a
                    href="/pages/data-sharing-opt-out"
                    className="underline underline-offset-2 transition-colors hover:text-muted-foreground"
                  >
                    Your Privacy Choices
                  </a>
                  .
                </p>
                <div className="mt-3 flex items-center gap-2">
                  <Button
                    onClick={dismiss}
                    size="sm"
                    className="h-8 rounded-full px-5 text-xs font-medium uppercase tracking-wider"
                  >
                    Got it
                  </Button>
                  <Button
                    asChild
                    variant="outline"
                    size="sm"
                    className="h-8 rounded-full px-5 text-xs font-medium uppercase tracking-wider"
                  >
                    <a href="/pages/data-sharing-opt-out">Your Privacy Choices</a>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
